import { render, staticRenderFns } from "./AddGLAccount.vue?vue&type=template&id=b481ff2e&"
import script from "./AddGLAccount.vue?vue&type=script&lang=js&"
export * from "./AddGLAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddGLAccount.vue?vue&type=style&index=0&id=b481ff2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports